// StandardHeader.js
import { Box, HStack, Heading } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types"; // สำหรับการตรวจสอบประเภทของ props (ถ้าไม่ได้ใช้ TypeScript)

export const StandardPageTitle = ({ title, textColor = "gray.600" }) => {
  const fontSize = "clamp(1.5rem, 1.5vmin, 1.8rem)";
  return (
    <Heading fontSize={fontSize} mb={2} textAlign="start">
      {title}
    </Heading>
  );
};

export const StandardHeader = ({
  title,
  bgColor,
  icon,
  textColor = "white", // ค่า default หากไม่ได้ส่งมา
  iconColor = "white", // ค่า default หากไม่ได้ส่งมา
  iconSize = "lg", // ค่า default หากไม่ได้ส่งมา
}) => {
  const fontSize = "clamp(1.5rem, 2vmin, 2rem)";
  return (
    <Box
      borderRadius="2xl" // คุณสามารถปรับ borderRadius ตามต้องการ เช่น "md", "lg"
      w="100%"
      bgColor={bgColor}
      color={textColor}
      p={2}
      boxShadow="md" // เพิ่มเงาเล็กน้อยเพื่อความสวยงาม (optional)
    >
      <HStack spacing={5} ml={5}>
        {icon && (
          <FontAwesomeIcon icon={icon} color={iconColor} size={iconSize} />
        )}
        <Heading
          as="h1"
          size={{ base: "md", md: "md" }}
          fontSize={fontSize}
          fontWeight="normal"
        >
          {title}
        </Heading>
      </HStack>
    </Box>
  );
};

// กำหนด PropTypes เพื่อการตรวจสอบ (ถ้าไม่ได้ใช้ TypeScript)
StandardHeader.propTypes = {
  title: PropTypes.string.isRequired,
  bgColor: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired, // FontAwesome icon object
  textColor: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.string,
};
